import { useContext } from 'react'
import {
  PlaybookQueryContext,
  PlaybookQueryContextType,
} from '../contexts/playbookQueryContext'

export const usePlaybookQueryContext = (
  ignoreError = false
): PlaybookQueryContextType => {
  const context = useContext(PlaybookQueryContext)

  if (!context && !ignoreError) {
    throw new Error(
      'usePlaybookQueryContext must be used within a PlaybookProvider'
    )
  }

  return (
    context ??
    ({
      data: undefined,
      isLoading: false,
      title: undefined,
      setTitle: () => {},
    } as unknown as PlaybookQueryContextType)
  )
}
